import FeedbackQuestions from "../../../../contents/docs/cdp/_snippets/feedback-questions.mdx";
import PostHogMaintained from "../../../../contents/docs/cdp/_snippets/posthog-maintained.mdx";
import * as React from 'react';
export default {
  FeedbackQuestions,
  PostHogMaintained,
  React
};